<template>
  <div :class="applyClass">
    {{ buildVersion }}
  </div>
</template>

<script>
export default {
  props: {
    /**
     * This string is prepended to the version string to denote that this is
     * a version
     */
    prependText: {
      type: String,
      required: false,
      default: "v",
    },
    /**
     * By default we apply the classes text-center and caption. Use this prop
     * to override that if desired
     */
    applyClass: {
      type: String,
      required: false,
      default: "text-center caption",
    },
  },
  /**
   * @return String
   */
  computed: {
    buildVersion: function () {
      return `${this.prependText}${window.amplifyRuntimeConfig.get(
        "VUE_APP_BUILD_VERSION"
      )}`;
    },
  },
};
</script>

<style lang="scss"></style>
